import React from 'react'
import { Link } from 'react-router-dom'

const Pagination = () => {
  return (
    <ul className="pagination flex-center flex-wrap gap-16">
    <li className="page-item">
      <Link
        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
        to="#"
      >
        <i className="ph-bold ph-arrow-left" />
      </Link>
    </li>
    <li className="page-item active">
      <Link
        className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
        to="#"
      >
        01
      </Link>
    </li>
    <li className="page-item">
      <Link
        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
        to="#"
      >
        <i className="ph-bold ph-arrow-right" />
      </Link>
    </li>
  </ul>
  )
}

export default Pagination
